import type { Directive, DirectiveBinding } from 'vue'
import { usePermissionStore } from '@/stores/permission'
import type { PermissionRequirement } from '@/types/permission'

function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
  const store = usePermissionStore()
  const value = binding.value as PermissionRequirement | undefined
  const hasPermission = store.canAccess(value)

  if (!hasPermission) {
    // 隐藏元素（不移除，以支持后续权限动态变化）
    el.style.display = 'none'
  } else {
    el.style.display = ''
  }
}

export const vPermission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  }
}
